<div class="exam-handler-modal">
  <div class="u-p0 modal__content">
    <div class="u-pl--">
      <wfm-patient-banner [patient]="patientInfo" type="skinny" [isDropdownHidden]="isPatientDropdownHidden"
      [isCompressed] = "isPatientBannerCompressed" [isIconHidden]="isPatientIconHidden">
      </wfm-patient-banner>
    </div>
      <!-- Notification -->
    <div id="notification-container">
      <div *ngFor="let note of notifications | keyvalue">
        <div class="u-pb u-pr+ u-pl++" *ngIf="note.value.show">
          <wfm-system-notification id="{{ note.value.id }}-notification" [type]="note.value.type" size="medium"
            [multiLineLayout]="note.value.multiLineLayout" [headingText]="note.value.label"
            [hideCloseButton]="note.value.hideClose" (close)="note.value.show = false">
          </wfm-system-notification>
        </div>
      </div>
    </div>
    <div class="u-p0">
      <form [formGroup]="examHandlerForm" *ngIf="!isLoading && !loadError" class="u-ml+">
        <div class="exam-info-header u-ml--">
          <span> {{'label.examInfo'| translate}} </span>
        </div>
        <div>
          <div class="clearfix">
            <div class="form__fieldset form-field u-m--">
              <div>
                <label for="scheduledDate" class="form__label form__label--bottom">
                  <span class="form__label-inner-wrap">
                    <span> {{'label.scheduledDate'| translate}}<span aria-label="required">*</span></span>
                  </span>
                </label>
                <div class="flex--nowrap flex--row" id="scheduledDate" (keydown)="dateBoxvalueChanged('scheduledDate')">
                  <wfm-date-picker
                    [format]="dateDisplayFormat"
                    [placeholder]="dateFormat"
                    [autoWidth]="true"
                    [hideOtherMonths]="true"
                    [min]="dob"
                    [max]="todayEod"
                    [rangeMode]="false"
                    [disabled]="formControls.scheduledDate.disabled || examHandlerForm.disabled"
                    [value]="formControls.scheduledDate.value"
                    (valueChange)="setUserSelection('scheduledDate',$event)">
                  </wfm-date-picker>
                </div>
              </div>
              <div *ngIf="formControls.scheduledDate.value === undefined && !scheduledDateInEditing">
                <div role="alert" class="form__error-text" id="scheduledDateError">
                  <svg-icon name="ico-form-error-16" [svgStyle]="{ 'width.px': 16, 'height.px': 16, fill: '#DF4661' }">
                  </svg-icon>
                  <span id="error-message" class="error-message">
                    {{ 'msg.error.dateRequired' | translate }}
                  </span>
                </div>
              </div>
            </div>

            <div class="form__fieldset form-field tiny-field u-m--">
              <div>
                <label for="scheduledTime" class="form__label form__label--bottom">
                  <span class="form__label-inner-wrap">
                    <span>{{ 'label.scheduledTime' | translate}} <span aria-label="required">*</span></span>
                  </span>
                </label>
                <div class="flex flex--nowrap flex--row" id="scheduledTime">
                  <wfm-time-picker
                    [type]="24"
                    [interval]="1"
                    [required]="true"
                    [disabled]="formControls.scheduledTime.disabled || examHandlerForm.disabled"
                    [error]="false"
                    [start]="startTime"
                    [end]="endTime"
                    [value]="formControls.scheduledTime.value"
                    (valueChange)="setUserSelection('scheduledTime',$event)">
                  </wfm-time-picker>
                </div>
              </div>
              <div *ngIf="formControls.scheduledTime.errors?.required">
                <div role="alert" class="form__error-text" id="scheduledTimeError">
                  <svg-icon name="ico-form-error-16" [svgStyle]="{ 'width.px': 16, 'height.px': 16, fill: '#DF4661' }">
                  </svg-icon>
                  <span id="error-message" class="error-message">
                    {{ 'msg.exam.error.timeRequired' | translate}}</span>
                </div>
              </div>
            </div>

            <div class="form__fieldset form-field tiny-field u-m--">
              <div>
                <label for="accessionNumber" class="form__label form__label--bottom">
                  <span class="form__label-inner-wrap">
                    <span>Accession #</span>
                  </span>
                </label>
                <div class="flex flex--nowrap flex--row" id="accessionNumber">
                  <input formControlName="accessionNumber" type="text" maxlength="16" class="textbox" (input)="onInput()" [tooltip]="formControls.accessionNumber.value"
                           [attr.aria-invalid]="formControls.accessionNumber.invalid" *ngIf="isAccessionNumberEditable; else elseBlock"/>
                  <ng-template #elseBlock>
                    <input formControlName="accessionNumber" type="text" class="readonly-textbox textbox u-pl0" [tooltip]="formControls.accessionNumber.value"
                           [attr.readonly]=true />
                  </ng-template>
                </div>
              </div>
              <div *ngIf="isAccessionNumberEditable && formControls.accessionNumber.invalid">
                <div role="alert" class="form__error-text" id="accessionNumberError">
                  <svg-icon name="ico-form-error-16" [svgStyle]="{ 'width.px': 16, 'height.px': 16, fill: '#DF4661' }">
                  </svg-icon>
                  <span id="error-message" class="error-message">
                    {{ 'msg.exam.error.invalid.accession.number' | translate}}</span>
                </div>
              </div>
            </div>

            <div class="form__fieldset form-field order-number u-m--">
              <div>
                <label for="orderNumber" class="form__label form__label--bottom">
                  <span class="form__label-inner-wrap">
                    <span>{{'label.orderNum' | translate}}</span>
                  </span>
                </label>
                <div id="orderNumber">
                  <wfm-select-dropdown
                    placeholder="placeholder.orderNum"
                    [items]="orderNumberList"
                    [disabled]="formControls.orderNumber.disabled || examHandlerForm.disabled"
                    [value]="formControls.orderNumber.value"
                    (valueChange)="setUserSelection('orderNumber',$event)">
                  </wfm-select-dropdown>
                </div>
              </div>
            </div>
          </div>
          <div class="clearfix">
            <div class="form__fieldset form-field u-m--">
              <div>
                <label for="studyDate" class="form__label form__label--bottom">
                  <span class="form__label-inner-wrap">
                    <span> {{'label.studyDate'| translate}}<span aria-label="required">*</span></span>
                  </span>
                </label>
                <div class="flex--nowrap flex--row" id="studyDate" (keydown)="dateBoxvalueChanged('studyDate')">
                  <wfm-date-picker
                    [format]="dateDisplayFormat"
                    [placeholder]="dateFormat"
                    [autoWidth]="true"
                    [hideOtherMonths]="true"
                    [min]="dob"
                    [max]="todayEod"
                    [error]="false"
                    [rangeMode]="false"
                    [disabled]="formControls.studyDate.disabled || examHandlerForm.disabled"
                    [value]="formControls.studyDate.value"
                    (valueChange)="setUserSelection('studyDate',$event)">
                  </wfm-date-picker>
                </div>
              </div>
              <div *ngIf="formControls.studyDate.value === undefined && !studyDateInEditing">
                <div role="alert" class="form__error-text" id="studyDateError">
                  <svg-icon name="ico-form-error-16" [svgStyle]="{ 'width.px': 16, 'height.px': 16, fill: '#DF4661' }">
                  </svg-icon>
                  <span id="error-message" class="error-message">
                    {{ 'msg.error.dateRequired' | translate}}</span>
                </div>
              </div>
            </div>

            <div class="form__fieldset form-field tiny-field u-m--">
              <div>
                <label for="studyTime" class="form__label form__label--bottom">
                  <span class="form__label-inner-wrap">
                    <span>{{ 'label.studyTime' | translate}} <span aria-label="required">*</span></span>
                  </span>
                </label>
                <div class="flex flex--nowrap flex--row" id="studyTime">
                  <wfm-time-picker
                    [type]="24"
                    [interval]="1"
                    [required]="true"
                    [disabled]="formControls.studyTime.disabled || examHandlerForm.disabled"
                    [error]="false"
                    [start]="startTime"
                    [end]="endTime"
                    [value]="formControls.studyTime.value"
                    (valueChange)="setUserSelection('studyTime',$event)">
                  </wfm-time-picker>
                </div>
              </div>
              <div *ngIf="formControls.studyTime.errors?.required">
                <div role="alert" class="form__error-text" id="studyTimeError">
                  <svg-icon name="ico-form-error-16" [svgStyle]="{ 'width.px': 16, 'height.px': 16, fill: '#DF4661' }">
                  </svg-icon>
                  <span id="error-message" class="error-message">
                    {{ 'msg.exam.error.timeRequired' | translate}}</span>
                </div>
              </div>
            </div>
            <div class="form__fieldset form-field tiny-field u-m--">
              <div>
                <label for="priority" class="form__label form__label--bottom">
                  <span class="form__label-inner-wrap">
                    <span>{{ 'label.priority' | translate}}</span>
                  </span>
                </label>
                <div id="priority">
                  <wfm-select-dropdown
                    placeholder="label.priority"
                    [required]="true"
                    [items]="priorityList"
                    labelField="priorityDesc"
                    [disabled]="formControls.priority.disabled || examHandlerForm.disabled"
                    [value]="formControls.priority.value"
                    (valueChange)="setUserSelection('priority',$event)">
                  </wfm-select-dropdown>
                </div>
              </div>
            </div>

            <div class="form__fieldset form-field u-m--">
              <div>
                <label for="referringPhysician" class="form__label form__label--bottom">
                  <span class="form__label-inner-wrap">
                    <span>{{'label.referringPhysician' | translate}}</span>
                  </span>
                </label>
                <div id="referringPhysician">
                  <wfm-select-dropdown
                    placeholder="placeholder.referringPhysician"
                    [search]="true"
                    [items]="referringPhysicianList"
                    labelField="formalName"
                    [disabled]="examHandlerForm.disabled"
                    [value]="formControls.referringPhysician.value"
                    (valueChange)="setUserSelection('referringPhysician',$event)">
                  </wfm-select-dropdown>
                </div>
              </div>
            </div>
          </div>
          <div class="clearfix">
            <div class="form__fieldset form-field u-m--">
              <div>
                <label for="procedureDescription" class="form__label form__label--bottom">
                  <span class="form__label-inner-wrap">
                    <span>{{ 'label.procedureDescription' | translate}} <span aria-label="required">*</span></span>
                  </span>
                </label>
                <div id="procedureDescription">
                  <wfm-select-dropdown
                    placeholder="placeholder.ProcedureDesc"
                    [search]="true"
                    [required]="true"
                    [items]="procedureDescList"
                    labelField="procedureDesc"
                    [disabled]="formControls.procedureDescription.disabled || examHandlerForm.disabled"
                    [value]="formControls.procedureDescription.value"
                    (valueChange)="updateProcedureSelection($event)">
                  </wfm-select-dropdown>
                </div>
              </div>
            </div>

            <div class="form__fieldset form-field u-m--">
              <div>
                <label for="procedureCode" class="form__label form__label--bottom">
                  <span class="form__label-inner-wrap">
                    <span>{{'label.procedureCode' | translate}}</span>
                  </span>
                </label>
                <div class="flex flex--nowrap flex--row" id="procedureCode">
                  <input formControlName="procedureCode" type="text" class="readonly-textbox textbox u-pl0" [tooltip]="formControls.procedureCode.value"
                    readonly />
                </div>
              </div>
            </div>

            <div class="form__fieldset form-field u-m--">
              <div>
                <label for="performingPhysician" class="form__label form__label--bottom">
                  <span class="form__label-inner-wrap">
                    <span>{{'label.performingPhysician' | translate}}</span>
                  </span>
                </label>
                <div id="performingPhysician">
                  <wfm-select-dropdown
                    placeholder="placeholder.performingPhysician"
                    [search]="true"
                    [items]="performingPhysicianList"
                    labelField="formalName"
                    [disabled]="formControls.performingPhysician.disabled || examHandlerForm.disabled"
                    [value]="formControls.performingPhysician.value"
                    (valueChange)="setUserSelection('performingPhysician',$event)">
                  </wfm-select-dropdown>
                </div>
              </div>
            </div>

          </div>
          <div class="flex-row">
            <div class="flex-col">
              <div class="form__fieldset u-m--">
                <div>
                  <label for="departmentName" class="form__label form__label--bottom">
                    <span class="form__label-inner-wrap">
                      <span>{{'label.departmentName' | translate}}</span>
                    </span>
                  </label>
                  <div id="departmentName">
                    <wfm-select-dropdown
                      placeholder="placeholder.departmentName"
                      [search]="true"
                      [required]="true"
                      [items]="departmentsList"
                      labelField="departmentName"
                      [disabled]="formControls.departmentName.disabled || examHandlerForm.disabled"
                      [value]="formControls.departmentName.value"
                      (valueChange)="setUserSelection('departmentName',$event)">
                    </wfm-select-dropdown>
                  </div>
                </div>
              </div>

              <div class="form__fieldset u-m--">
                <div>
                  <label for="orderingLocation" class="form__label form__label--bottom">
                    <span class="form__label-inner-wrap">
                      <span>{{'label.orderingLocation' | translate}}</span>
                    </span>
                  </label>
                  <div id="orderingLocation">
                    <wfm-select-dropdown
                      placeholder="placeholder.orderingLocation"
                      [search]="true"
                      [required]="true"
                      [items]="orderingLocationList"
                      labelField="orderingLocationName"
                      [disabled]="formControls.orderingLocation.disabled || examHandlerForm.disabled"
                      [value]="formControls.orderingLocation.value"
                      (valueChange)="setUserSelection('orderingLocation',$event)">
                    </wfm-select-dropdown>
                  </div>
                </div>
              </div>
            </div>
            <div class="form__fieldset clinical-comment u-m--">
              <div>
                <label for="clinicalComments" class="form__label form__label--top label__container form__label--bottom">
                  <span class="form__label-inner-wrap">
                    <span>{{'label.clinicalComment' | translate}}</span>
                  </span>
                </label>
                <div>
                    <div class="textarea">
                      <textarea
                      rows="5"
                      formControlName="clinicalComments"
                      id="clinicalComments"
                      tabindex="12"
                      placeholder="{{'placeholder.clinicalComment' | translate}}"
                      class="textarea__input"
                      (input)="onInput()"
                      [attr.aria-invalid]="formControls.clinicalComments.invalid && (formControls.clinicalComments.touched || formControls.clinicalComments.dirty)">
                    </textarea>
                    </div>
                    <div *ngIf="formControls.clinicalComments.invalid && (formControls.clinicalComments.touched || formControls.clinicalComments.dirty)">
                      <div role="alert" class="form__error-text" id="clinicalCommentError">
                        <svg-icon name="ico-form-error-16" [svgStyle]="{ 'width.px': 16, 'height.px': 16, fill: '#DF4661' }">
                        </svg-icon>
                        <span id="error-message" class="error-message">
                          {{ 'msg.error.invalidInputCharacters' | translate}}</span>
                      </div>
                    </div>
                  </div>
              </div>
            </div>
          </div>
        </div>
      </form>

      <!-- Spinner -->
      <div *ngIf="isLoading" id="spinner-component" class="box u--1/1 flex flex--center u-mv u-pv readonly-textbox">
        <wfm-spinner [show]="true" [size]="40"></wfm-spinner>
      </div>
    </div>
  </div>

    <!-- Modal Footer -->
    <div class="flex flex--row u-p" style="justify-content: right;">
      <button type="button"
              *ngIf="loadError"
              class="button button--reject button--tertiary u-ml--"
              (click)="closeModal(false); $event.stopPropagation()">
        {{ 'button.ok' | translate }}
      </button>

      <button type="button"
              *ngIf="!loadError"
              class="button button--reject button--tertiary u-ml--"
              (click)="closeModal(true); $event.stopPropagation()">
        {{ 'button.viewInDxhub' | translate }}
      </button>

      <button type="button"
              *ngIf="!loadError"
              [disabled]="isLoading || !examHandlerForm.dirty || examHandlerForm.disabled"
              class="button button--tertiary u-ml--"
              (click)="resetForm(); $event.stopPropagation()">
        {{ 'button.reset' | translate }}
      </button>

      <button type="button"
              *ngIf="!loadError"
              [disabled]="isLoading || examHandlerForm.invalid || !examHandlerForm.dirty || examHandlerForm.disabled || isErrorPopUp"
              class="button button--primary button--accept u-ml--"
              (click)="confirmExamUpdate(); $event.stopPropagation()">
        {{ 'button.save' | translate }}
      </button>
    </div>
</div>
